import React, { useEffect, useState } from "react";
import IsecNavbar from "./IsecNavbar";
import "./pages-css/IsecDashboard.css";
import { useAuth } from "../../Context/UserContext";
import IsecNavbar2 from "./IsecNavbar2";
import { LineChart, PieChart } from "@mui/x-charts";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { url } from "../../constants/url";
import { toast } from "react-toastify";
import ClientNavbar1 from "../../Client-components/Pages/ClientNavbar1";
import ProgressBar from "../Modal/ProgressBar";
import SearchBar from "../Modal/SearchBar";
import ProjectNameList from "../Modal/ProjectNameList";
import ProjectHeader from "../Modal/ProjectHeader";
import ProjectTabContent from "../Modal/ProjectTabContent";

const IsecDashboard = () => {

  const navigate = useNavigate()

  const location = useLocation();
  const [inprogressCount, setInprogressCount] = useState(0)
  const [retestingCount, setRetestingCount] = useState(0)
  const [completedCount, setCompletedCount] = useState(0)
  const [totalProjectsCount, setTotalProjectsCount] = useState(0)
  const [singleProjectData, setSingleProjectData] = useState('')
  const [singleProjectVulnerability, setSingleProjectVulnerability] = useState([])

  const [assignedLead, setAssignedLead] = useState(0)
  const [assignPentester, setAssignPentester] = useState(0)
  const [retestLead, setRetestLead] = useState(0)
  const [retestPentester, setRetestPentester] = useState(0)
  const [certInLead, setCertInLead] = useState(0)
  const [certInPentester, setCertInPentester] = useState(0)
  const [nonCertInLead, setNonCertInLead] = useState(0)
  const [nonCertInPentester, setNonCertInPentester] = useState(0)
  const [reportProject, setReportProject] = useState([])

  const [vulSeverity, setVulSeverity] = useState({
    Critical: 0,
    High: 0,
    Medium: 0,
    Low: 0,
    Info: 0
  })

  const [vulFixedCount, setVulFixedCount] = useState(0)
  const [pendingVulRetest, setPendingVulRetest] = useState(0)

  const [allProjects, setAllProjects] = useState([]);
  const [projectDetails, setProjectDetails] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [toggleProjectDetails, setToggleProjectDetails] = useState("overview");

  const [showMonth, setShowMonth] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [noProjectsFound, setNoProjectsFound] = useState(false);
  const currentMonthIndex = new Date().getMonth();

  const [searchText, setSearchText] = useState("");

  const [analystProjectList, setAnalystProjectList] = useState([])

  const statusPriority = {
    "Inprogress": 1,
    "Retesting": 2,
    "Completed": 3,
  };

  const [dataByYear, setDataByYear] = useState({
    '2025': Array(12).fill(0),
    '2026': Array(12).fill(0),
    '2027': Array(12).fill(0),
  });

  const availableYears = ["2024", "2025", "2026"];

  const [selectedYear, setSelectedYear] = useState('2026');

  const { emailVer, logout, userRole, isSidebarCollapsed } = useAuth();

  const severityData1 = [
    { id: 0, value: vulSeverity.Critical, label: 'Critical', color: '#c00000' },
    { id: 1, value: vulSeverity.High, label: 'High', color: '#ff0000' },
    { id: 2, value: vulSeverity.Medium, label: 'Medium', color: '#ffc000' },
    { id: 3, value: vulSeverity.Low, label: 'Low', color: '#ffff00' },
    { id: 4, value: vulSeverity.Info, label: 'Info', color: '#00b050' },
  ]

  // Refer project.js file for backend code
  const fetchProjectCount = async () => {
    try {
      const response = await fetch(`${url}/projectcount`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return;
      }
      const projects = await response.json();

      if (userRole === 'manager') {
        const statuses = projects?.map((project) => project.status);
        updateCounts(statuses);
        return
      }

      setAssignedLead(projects.assignedLead)
      setAssignPentester(projects.assignPentester)
      setRetestLead(projects.retestLead)
      setRetestPentester(projects.retestPentester)
      setCertInLead(projects.certInLead)
      setCertInPentester(projects.certInPentester)
      setNonCertInLead(projects.nonCertInLead)
      setNonCertInPentester(projects.nonCertInPentester)


    } catch (error) {
      console.error("Error fetching project count:", error);
    }
  };

  const updateCounts = (statuses) => {
    let inprogressCount = 0;
    let retestingCount = 0;
    let completedCount = 0;

    statuses.forEach((status) => {
      switch (status) {
        case "Inprogress":
          inprogressCount++;
          break;
        case "Retesting":
          retestingCount++;
          break;
        case "Completed":
          completedCount++;
          break;
        default:
          break;
      }
    });
    setInprogressCount(inprogressCount);
    setRetestingCount(retestingCount);
    setCompletedCount(completedCount);
    setTotalProjectsCount(statuses.length)

    window.scrollTo(0, 0);
  };

  const updateVulCounts = (vulCount) => {
    let vulCritical = 0;
    let vulHigh = 0;
    let vulMedium = 0;
    let vulLow = 0;
    let vulInfo = 0

    vulCount.forEach((vul) => {
      switch (vul.severity || vul) {
        case 'Critical':
          vulCritical++;
          break;
        case 'High':
          vulHigh++;
          break;
        case 'Medium':
          vulMedium++;
          break;
        case 'Low':
          vulLow++;
          break;
        case 'Info':
          vulInfo++;
          break;
        default:
          break;
      }
    });
    setVulSeverity({
      Critical: vulCritical,
      High: vulHigh,
      Medium: vulMedium,
      Low: vulLow,
      Info: vulInfo,
    });
  };


  const fetchReportedVulnerabilities = async () => {
    try {
      const response = await fetch(`${url}/reportedvulnerabilities`, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });

      const data = await response.json();

      if (response.ok && Array.isArray(data)) {
        updateVulCounts(data);
      } else {
        console.error("Unexpected response format or error:", data.message);
      }
    } catch (error) {
      console.error("Error fetching reported vulnerabilities:", error);
    }
  };

  const fetchProjectDetails = async (monthIndex = selectedMonth) => {
    try {
      const response = await fetch(`${url}/isecuriondashboardprojectdetails`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      const data = await response.json();
      setAllProjects(data || []);

      const monthNum = Number(monthIndex);

      const filteredProjects = (data || []).filter((project) => {
        if (!project.time) return false;
        const projectDate = new Date(project.time);

        const projectMonth = projectDate.getMonth(); // 1–12
        return projectMonth === monthNum;
      });

      const sorted = filteredProjects.sort(
        (a, b) => (statusPriority[a.status] ?? 99) - (statusPriority[b.status] ?? 99)
      );

      if (sorted.length === 0) {
        setNoProjectsFound(true);
        setProjectDetails([]);
        setSelectedProjectId(null);
      } else {
        setNoProjectsFound(false);
        setProjectDetails(sorted);
        const targetProjectId = location.state?.projectId || sorted[0]?._id;
        if (targetProjectId) {
          setSelectedProjectId(targetProjectId);
          selectedProjectDetails(targetProjectId);
        }
      }
    } catch (error) {
      console.error("❌ Error fetching project details:", error);
      setNoProjectsFound(true);
    }
  };

  // 🧩 Calculate filtered and sorted projects once
  const activeProjects = reportProject
    .map((project) => {
      const today = new Date();
      const dueDate = new Date(project.duedate);
      let remainingDays = 0;

      const calculateWorkingDays = (startDate, endDate) => {
        let count = 0;
        const currentDate = new Date(startDate);

        while (currentDate <= endDate) {
          const day = currentDate.getDay();
          if (day !== 0 && day !== 6) count++;
          currentDate.setDate(currentDate.getDate() + 1);
        }

        return count;
      };

      if (dueDate >= today) {
        remainingDays = calculateWorkingDays(today, dueDate);
      }

      return { ...project, remainingDays };
    })
    // ✅ exclude 0-day and overdue projects
    .filter((p) => p.remainingDays > 0)
    // ✅ sort by nearest deadline
    .sort((a, b) => a.remainingDays - b.remainingDays);

  const fetchAnalystProjectDetails = async () => {
    try {
      const response = await fetch(`${url}/isecsecurityanalystdashboarddetails`, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" }
      });

      const analystData = await response.json();

      // Sort by priority
      const sorted = analystData.sort((a, b) => {
        return (statusPriority[a.status] ?? 99) - (statusPriority[b.status] ?? 99);
      });

      // Compute severity counts per project
      const projectsWithCounts = sorted.map(project => {
        const vulnerabilities = project.vulnerabilities || [];

        const severityCounts = vulnerabilities.reduce(
          (acc, vul) => {
            const severity = vul?.severity?.trim()?.toLowerCase();
            if (!severity) return acc;

            switch (severity) {
              case "critical":
                acc.Critical++;
                break;
              case "high":
                acc.High++;
                break;
              case "medium":
                acc.Medium++;
                break;
              case "low":
                acc.Low++;
                break;
              case "info":
              case "informational":
                acc.Info++;
                break;
              default:
                break;
            }
            return acc;
          },
          { Critical: 0, High: 0, Medium: 0, Low: 0, Info: 0 }
        );

        return { ...project, severityCounts };
      });

      setAnalystProjectList(projectsWithCounts);

      const reportDate = sorted.filter((project) => {
        const reportDateValue = project.duedate;
        return reportDateValue && !isNaN(new Date(reportDateValue).getTime())
      })
      setReportProject(reportDate)

      // ---- Yearwise project data for chart ----
      const graphData = sorted.filter(p => p.testStartDate);
      let yearwiseData = {
        "2024": Array(12).fill(0),
        "2025": Array(12).fill(0),
        "2026": Array(12).fill(0)
      };

      graphData.forEach(project => {
        const date = new Date(project.testStartDate);
        const year = date.getFullYear();
        const month = date.getMonth();
        if (yearwiseData[year]) {
          yearwiseData[year][month] += 1;
        }
      });

      setDataByYear(yearwiseData);
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  }

  const selectedProjectDetails = async (projectId) => {
    try {
      const response = await fetch(`${url}/selectedprojectdetails?projectId=${projectId}`, {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        }
      })
      const data = await response.json()
      setSingleProjectData(data.project)
      setSingleProjectVulnerability(data.vulnerabilityData)
    } catch (error) {
      console.log(error)
    }
  }

  const fixedCount = () => {
    const count = singleProjectVulnerability.filter(vul => vul.retestStatus === 'Fixed').length;
    setVulFixedCount(count);
  };

  const pendingRetest = () => {
    const count = singleProjectVulnerability.filter(vul => vul.retestStatus === '' || vul.retestStatus === null).length;
    setPendingVulRetest(count);
  };

  useEffect(() => {
    fetchProjectCount();
    if (userRole !== 'manager') {
      fetchAnalystProjectDetails();
    }

    fixedCount();
    pendingRetest();
    fetchReportedVulnerabilities()
    if (!emailVer.endsWith("@isecurion.com")) {
      logout();
      return;
    }
  }, [emailVer, logout, userRole]);

  useEffect(() => {
    handleToggle(toggleProjectDetails);
  }, [toggleProjectDetails]);

  useEffect(() => {
    fetchProjectDetails(selectedMonth);
  }, [selectedMonth]);

  useEffect(() => {
    const monthNum = Number(selectedMonth);
    const searchLower = searchText.toLowerCase();

    const filtered = allProjects.filter((project) => {
      if (!project.time) return false;

      const projectDate = new Date(project.time);
      if (isNaN(projectDate)) return false;

      const projectMonth = projectDate.getMonth();
      const isSameMonth = projectMonth === monthNum;
      if (!searchLower) return isSameMonth;

      return (
        isSameMonth &&
        (
          project.clientName?.toLowerCase().includes(searchLower) ||
          project.projectName?.toLowerCase().includes(searchLower)
        )
      );
    });

    const sorted = filtered.sort(
      (a, b) => (statusPriority[a.status] ?? 99) - (statusPriority[b.status] ?? 99)
    );

    setProjectDetails(sorted);
    setNoProjectsFound(sorted.length === 0);
  }, [searchText, selectedMonth, allProjects]);


  const handleToggle = (tab, singleProjectData) => {
    return <ProjectTabContent tab={tab}
      singleProjectData={singleProjectData}
      singleProjectVulnerability={singleProjectVulnerability}
      selectedProjectDetails={selectedProjectDetails}
    />;
  };

  const calculateProgress = (project) => {
    let progress = 0;

    // 1️⃣ Initial progress based on main status
    if (project.status === 'Inprogress') progress = 25;
    else if (project.status === 'Retesting') progress = 60;
    else if (project.status === 'Completed') progress = 100;

    // 2️⃣ Add more progress based on milestones
    if (project.phase1Status) progress += 15;  // Phase 1 done
    if (project.retestStatus === 'Fixed') progress += 15; // Retesting fixed
    if (project.completionReportStatus) progress = 100; // Final done

    // 3️⃣ Ensure it doesn’t exceed 100%
    return Math.min(progress, 100);
  };

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const monthsChart = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const getProgressValue = (project) => {
    if (!project) return 0;

    const { status, phase1Status, testEndDate, phase2ReportDate } = project;

    if (status === "Completed" && phase2ReportDate) {
      return 100;
    } else if (status === "Retesting") {
      return 76;
    } else if (phase1Status === true) {
      return 51;
    } else if (status === "Inprogress") {
      return 24;
    } else {
      return 0;
    }
  };

  return (
    <div className="isecurion-dashboard">
      <div>
        <div className='client_navabr1'>
          <ClientNavbar1 />
        </div>
        <div className='isecurion_navbar_second'><IsecNavbar2 /></div>
      </div>

      <div className='wrap_isecurion_navbar_dashboard'>
        <div className={isSidebarCollapsed ? 'isecuriondash-navbar' : 'isecuriondash_close_navbar'}>
          <IsecNavbar />
        </div>

        <div className={isSidebarCollapsed ? 'wrap_isecurion_dashboard_data_open' : 'wrap_isecurion_dashboard_data'}>
          <div className="isecDashboard_project_widgets_container">

            <div className="isecDashboard_widgets">
              {/* Assigned Projects */}
              <div className="isecDashboard_widgets_items">
                <div className="isecDashboard_project_details">
                  <div className="isecDashboard_project_details_title">
                    {userRole && userRole === "manager" ? "Total Projects" : "Assigned Projects"}
                  </div>
                  <div className="isecDashboard_project_details_count">{userRole && userRole === "manager" ? totalProjectsCount : (
                    <p style={{ fontSize: "11.5px" }}>Project Lead: {assignedLead} | Pentester: {assignPentester}</p>
                  )}</div>
                </div>
                <div className="isecDashboard_project_icons">
                  {userRole && userRole === "manager" ? (
                    <Icon icon="fluent:document-arrow-up-20-regular" width="24" height="24" color="#16A34A" />
                  ) : (
                    <Icon icon="carbon:task-complete" width="24" height="24" color="#16A34A" />
                  )}
                </div>
              </div>
            </div>

            {/* Retests Pending*/}
            <div className="isecDashboard_widgets">
              <div className="isecDashboard_widgets_items">
                <div className="isecDashboard_project_details">
                  <div className="isecDashboard_project_details_title">
                    {userRole && userRole === "manager" ? "Ongoing Project" : "Retests Pending"}
                  </div>
                  <div className="isecDashboard_project_details_count">{userRole && userRole === "manager" ? inprogressCount : (
                    <p style={{ fontSize: "11.5px" }}>Project Lead: {retestLead} | Pentester: {retestPentester}</p>
                  )}</div>
                </div>
                <div className="isecDashboard_project_icons_due">
                  {userRole && userRole === "manager" ? (
                    <Icon icon="fluent:document-settings-20-regular" width="24" height="24" color="#EF4444" />
                  ) : (
                    <Icon icon="carbon:task-settings" width="24" height="24" color="#EF4444" />
                  )}
                </div>
              </div>
            </div>

            {/* Cert - In Projects */}
            <div className="isecDashboard_widgets">
              <div className="isecDashboard_widgets_items">
                <div className="isecDashboard_project_details">
                  <div className="isecDashboard_project_details_title">
                    {userRole && userRole === "manager" ? "Completed Project" : "Cert-In Projects"}
                  </div>
                  <div className="isecDashboard_project_details_count">{userRole && userRole === "manager" ? completedCount : (
                    <p style={{ fontSize: "11.5px" }}>Project Lead: {certInLead} | Pentester: {certInPentester}</p>
                  )}</div>
                </div>
                <div className="isecDashboard_project_icons">
                  {userRole && userRole === "manager" ? (
                    <Icon icon="carbon:document-tasks" width="24" height="24" color="#2563EB" />
                  ) : (
                    <Icon icon="fluent:document-briefcase-32-regular" width="24" height="24" color="#2563EB" />
                  )}
                </div>
              </div>
            </div>

            {/* Non Cert - In Projects*/}
            <div className="isecDashboard_widgets">
              <div className="isecDashboard_widgets_items">
                <div className="isecDashboard_project_details">
                  <div className="isecDashboard_project_details_title">
                    {userRole && userRole === "manager" ? "Retest Project" : "Non Cert-In Projects"}
                  </div>
                  <div className="isecDashboard_project_details_count">{userRole && userRole === "manager" ? retestingCount : (
                    <p style={{ fontSize: "11.5px" }}>Project Lead: {nonCertInLead} | Pentester: {nonCertInPentester}</p>
                  )}</div>
                </div>
                <div className="isecDashboard_project_icons">
                  {userRole && userRole === "manager" ? (
                    <Icon icon="fluent:document-sync-24-regular" width="24" height="24" color="#A250ED" />
                  ) : (
                    <Icon icon="fluent:document-data-lock-24-regular" width="24" height="24" color="#A250ED" />
                  )}
                </div>
              </div>
            </div>

          </div>

          {userRole && userRole === "manager" ? (
            <div className="wrap_isecurion_below_first_row_content">
              {/* search and filter */}
              <div className="isecDashboard_search_project_and_filter_container">
                <div className="isecDashboard_search_project_container">
                  {/* pass placeholder and setSearchText to hole the text */}
                  <SearchBar
                    placeholder="Search  by Client or Project name..."
                    setSearchText={setSearchText}
                  />
                </div>
                <div className="isecDashboard_search_project_filter_container">
                  <div
                    className="isecDashboard_search_project_filter_icon"
                    onClick={() => setShowMonth(!showMonth)}>
                    <p style={{ marginTop: '3px', fontSize: "13px" }}>{months[selectedMonth]}</p>
                    <Icon icon="bx:menu-alt-right" width="24" height="24" />
                  </div>

                  <div
                    className="isecDashboard_search_project_filtelist"
                    style={{ display: !showMonth ? "none" : "block" }}>
                    {months.map((month, index) => (
                      <button
                        key={month}
                        className={index === selectedMonth ? "active-month" : ""}
                        onClick={() => {
                          setSelectedMonth(index);
                          setShowMonth(false);
                        }}>
                        {month}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* project list horizontal */}

              {noProjectsFound ? (
                <div className="no-projects-message">
                  <p>No projects found{searchText ? ` for “${searchText}”` : ` in ${months[selectedMonth]}`}</p>
                </div>
              ) : (
                <>
                  <ProjectNameList
                    projects={projectDetails}
                    selectedProjectId={selectedProjectId}
                    setSelectedProjectId={setSelectedProjectId}
                    selectedProjectDetails={selectedProjectDetails}
                  />

                  {/* project status */}
                  <div className="isecurionDashboard_single_project_status_container">
                    <h2 className="isecurionDashboard_single_project_status_heading">

                      Status: {singleProjectData?.status}
                    </h2>

                    <ProgressBar fill={calculateProgress(singleProjectData)} />

                    <div className="isecurionDashboard_single_project_details_container">
                      {/* critical issues */}
                      <div className="isecurionDashboard_single_project_details">
                        <div className="isecurionDashboard_single_project_details_title">
                          Critical Issues
                        </div>
                        <div className="isecurionDashboard_single_project_details_count">
                          {singleProjectVulnerability?.filter(
                            (vuln) => vuln.severity === "Critical" || vuln.severity === "High"
                          ).length}
                        </div>

                      </div>

                      {/* pending issues */}

                      <div className="isecurionDashboard_single_project_details">
                        <div className="isecurionDashboard_single_project_details_title">
                          Pending Retests
                        </div>
                        <div className="isecurionDashboard_single_project_details_count">
                          {singleProjectData?.status === "Inprogress" || 'Completed' ? '0' : `${pendingVulRetest}`}
                        </div>
                      </div>

                      {/* Assigned Developer */}
                      <div className="isecurionDashboard_single_project_details">
                        <div className="isecurionDashboard_single_project_details_title">
                          Assigned Pentester
                        </div>
                        <div className="isecurionDashboard_single_project_details_count">
                          {singleProjectData?.pentesters?.length}
                        </div>
                      </div>

                      {/* fixed in progress */}
                      <div className="isecurionDashboard_single_project_details">
                        <div className="isecurionDashboard_single_project_details_title">
                          Fixed Issues
                        </div>
                        <div className="isecurionDashboard_single_project_details_count">
                          {singleProjectData.status === "Inprogress" ? '0' : `${vulFixedCount}`}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* project details */}
                  <ProjectHeader setToggleProjectDetails={setToggleProjectDetails} singleProjectData={singleProjectData} />
                  {handleToggle(toggleProjectDetails, singleProjectData)}
                </>
              )}

            </div>
          ) : (
            <>
              {/* My Active Engagements */}
              <div className="isecDashboard_my_active_engagements_container">
                <div className="isecDashboard_my_active_engagements_title">
                  My Active Engagements
                </div>

                <div className="isecDashboard_my_active_engagements_cards_container">
                  {analystProjectList.filter((data) => data.status === "Inprogress").length > 0 ? (
                    analystProjectList
                      .filter((data) => data.status === "Inprogress")
                      .map((data, index) => (
                        <div className="isecDashboard_my_active_engagements_cards" key={index} onClick={() => navigate(`/projects/status/${data._id}`)}>
                          <div className="isecDashboard_my_active_engagements_card_project_client_name">
                            {data.projectName}
                          </div>

                          <div className="isecDashboard_my_active_engagements_card_project_container">
                            <div className="isecDashboard_my_active_engagements_card_project_name">
                              {data.clientName}
                            </div>

                            <div className="isecDashboard_my_active_engagements_card_project_analyst">
                              {data.applicationType}
                            </div>
                          </div>

                          <div className="isecDashboard_my_active_engagements_progress_container">
                            <div className="isecDashboard_my_active_engagements_progress_title">
                              {data.status}
                            </div>

                            <ProgressBar fill={getProgressValue(data)} />
                          </div>

                          <div className="isecDashboard_my_active_engagements_card_project_days_remaining_container">
                            <div className="isecDashboard_my_active_engagements_card_project_days_remaining">

                            </div>

                            <div className="isecDashboard_my_active_engagements_card_project_vul_container">
                              <span className="isecDashboard_my_active_engagements_card_project_vul">
                                <span className="isecDashboard_my_active_engagements_card_project_critacl"></span>
                                <span className="isecDashboard_my_active_engagements_card_project_vul_count">
                                  {data.severityCounts?.Critical || 0}
                                </span>
                              </span>

                              <span className="isecDashboard_my_active_engagements_card_project_vul">
                                <span className="isecDashboard_my_active_engagements_card_project_high"></span>
                                <span className="isecDashboard_my_active_engagements_card_project_vul_count">
                                  {data.severityCounts?.High || 0}
                                </span>
                              </span>

                              <span className="isecDashboard_my_active_engagements_card_project_vul">
                                <span className="isecDashboard_my_active_engagements_card_project_medium"></span>
                                <span className="isecDashboard_my_active_engagements_card_project_vul_count">
                                  {data.severityCounts?.Medium || 0}
                                </span>
                              </span>

                              <span className="isecDashboard_my_active_engagements_card_project_vul">
                                <span className="isecDashboard_my_active_engagements_card_project_low"></span>
                                <span className="isecDashboard_my_active_engagements_card_project_vul_count">
                                  {data.severityCounts?.Low || 0}
                                </span>
                              </span>

                              <span className="isecDashboard_my_active_engagements_card_project_vul">
                                <span className="isecDashboard_my_active_engagements_card_project_info"></span>
                                <span className="isecDashboard_my_active_engagements_card_project_vul_count">
                                  {data.severityCounts?.Info || 0}
                                </span>
                              </span>
                            </div>

                          </div>
                        </div>
                      ))) : (
                    <div style={{ textAlign: "center" }} className='piechart_symbol'>
                      <p style={{ fontSize: "16px", color: "#666" }}>No Ongoing Projects</p>
                    </div>
                  )}

                </div>
              </div>

              {/* Request Queue and ongoing Retestes  */}
              <div className="isecDashboard_request_queue_and_ongoing_container">
                {/* Request Queue */}
                <div className="isecDashboard_request_queue_container">
                  <div className="isecDashboard_request_queue_container_title">
                    Reported Vulnerabilities
                  </div>

                  <div className="isec-dashboard-reported-vul">
                    <div >
                      {severityData1.reduce((sum, item) => sum + item.value, 0) > 0 ? (
                        <PieChart
                          series={[
                            {
                              data: severityData1,
                              highlightScope: { fade: "global", highlight: "item" },
                              faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
                              arcLabel: "value",
                              arcLabelMinAngle: 20,
                              innerRadius: 35,
                            },
                          ]}
                          // width={400}
                          height={180}
                          legend={{
                            itemGap: 15,
                            labelStyle: { fontSize: 13 },
                          }}
                        />
                      ) : (
                        <div style={{ textAlign: "center" }} className='piechart_symbol'>
                          <p style={{ fontSize: "16px", color: "#666" }}>No Data Available</p>
                        </div>
                      )}
                    </div>
                  </div>


                </div>

                {/* Ongoing Retests */}
                <div className="isecDashboard_ongoing_request_container">
                  <div className="isecDashboard_ongoing_request_container_title">
                    Ongoing Retests
                  </div>

                  <div className="isecDashboard_ongoing_request_table_container">
                    <table>
                      <thead>
                        <tr>
                          <th>Sl No.</th>
                          <th>Project Name</th>
                          <th>Client Name</th>
                          <th>Application Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {analystProjectList &&
                          analystProjectList
                            .filter((data) => data.status === 'Retesting')
                            .map((data, index) => (
                              <tr key={index} onClick={() => navigate(`/projects/status/${data._id}`)}>
                                <td >{index + 1}</td>
                                <td>{data.projectName}</td>
                                <td>{data.clientName}</td>
                                <td>{data.applicationType}</td>
                              </tr>
                            ))}

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* year wise project graph and CERT in report deadlines */}
              <div className="isecDashboard_year_wise_project_graph_and_cert_in_report_deadline_container">
                <div className="isecDashboard_year_wise_project_grap_container">
                  <div className="isecDashboard_year_wise_project_grap_container_title_container">
                    <div className="isecdashboard_year_wise_project_grap_title">
                      Year-wise Project
                    </div>

                    {/* Dropdown */}
                    <div className="isecDashboard_year_wise_project_graph_dropdown_container">
                      <div
                        className="isecDashboard_year_wise_project_graph_dropdown_heading"
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                      >
                        {selectedYear === "2024"
                          ? "Previous Year (2024)"
                          : selectedYear === "2025"
                            ? "This Year (2025)"
                            : "Next Year (2026)"}
                        {!dropdownOpen ? (
                          <Icon icon="material-symbols-light:keyboard-arrow-down" width="24" height="24" />
                        ) : (
                          <Icon icon="material-symbols-light:keyboard-arrow-up" width="24" height="24" />
                        )}
                      </div>

                      {dropdownOpen && (
                        <div className="isecDashboard_year_wise_project_graph_dropdown_list">
                          <button
                            onClick={() => {
                              setSelectedYear("2024");
                              setDropdownOpen(false);
                            }}
                          >
                            Previous Year (2024)
                          </button>
                          <button
                            onClick={() => {
                              setSelectedYear("2025");
                              setDropdownOpen(false);
                            }}
                          >
                            This Year (2025)
                          </button>
                          <button
                            onClick={() => {
                              setSelectedYear("2026");
                              setDropdownOpen(false);
                            }}
                          >
                            Next Year (2026)
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Line Chart */}
                  <div className="isecDashboard_year_wise_project_grap">
                    {dataByYear[selectedYear] ? (
                      <LineChart
                        xAxis={[
                          {
                            data: monthsChart,
                            scaleType: "point",
                            valueFormatter: (month) => month,
                          },
                        ]}
                        series={[
                          {
                            data: dataByYear[selectedYear],
                            color: "#5687F2",
                            curve: "linear",
                          },
                        ]}
                        height={250}
                      />
                    ) : (
                      <p style={{ textAlign: "center", padding: "20px" }}>
                        No data available for {selectedYear}
                      </p>
                    )}
                  </div>
                </div>

                {/* CERT - In Report Deadlines */}
                <div className="isecDashboard_cert_in_report_deadline_container">
                  <div className="isecDashboard_cert_in_report_deadline_title">
                    CERT-In Report Deadlines
                  </div>
                  {activeProjects.length === 0 ? (
                    <p>No Data Available</p>
                  ) : (
                    activeProjects.map((sortedProject, index) => (
                      <div
                        key={index}
                        className="isecDashboard_cert_in_report_deadline_list_container_items"
                      >
                        {sortedProject.projectName} - due in{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {sortedProject.remainingDays} days
                        </span>
                      </div>
                    ))
                  )}


                </div>
              </div>

              {/* Report Pipeline Overview and Recent Activity */}
              {/* <div className="isecDashboard_report_peline_and_recent_activity">
                <div className="isecDashboard_report_pipeline_container">
                  <div className="isecDashboard_report_pipeline_title">
                    Report Pipeline Overview / Report Status
                  </div>

                  <div className="isecDashboard_report_pipeline_"></div>
                </div>

                <div className="isecDashboard_recent_activity_container">
                  <div className="isecDashboard_recent_activity_title">
                    Recent Activity
                  </div>
                  <div className="isecDashboard_recent_activity_list_container">
                    <div className="isecDashboard_recent_activity_list_items">
                      <div className="isecDashboard_recent_activity_list_items_project_name_container">
                        <div className="isecDashboard_recent_activity_list_items_project_name">
                          Banking API Security(Project name)
                        </div>
                        <div className="isecDashboard_recent_activity_list_items_time">
                          2mins ago
                        </div>
                      </div>
                      <div className="isecDashboard_recent_activity_list_items_vul">
                        Critical vulnerability in login endpoint
                      </div>
                    </div>
                    <div className="isecDashboard_recent_activity_list_items">
                      <div className="isecDashboard_recent_activity_list_items_project_name_container">
                        <div className="isecDashboard_recent_activity_list_items_project_name">
                          Banking API Security(Project name)
                        </div>
                        <div className="isecDashboard_recent_activity_list_items_time">
                          2mins ago
                        </div>
                      </div>
                      <div className="isecDashboard_recent_activity_list_items_vul">
                        Critical vulnerability in login endpoint
                      </div>
                    </div>
                    <div className="isecDashboard_recent_activity_list_items">
                      <div className="isecDashboard_recent_activity_list_items_project_name_container">
                        <div className="isecDashboard_recent_activity_list_items_project_name">
                          Banking API Security(Project name)
                        </div>
                        <div className="isecDashboard_recent_activity_list_items_time">
                          2mins ago
                        </div>
                      </div>
                      <div className="isecDashboard_recent_activity_list_items_vul">
                        Critical vulnerability in login endpoint
                      </div>
                    </div>
                    <div className="isecDashboard_recent_activity_list_items">
                      <div className="isecDashboard_recent_activity_list_items_project_name_container">
                        <div className="isecDashboard_recent_activity_list_items_project_name">
                          Banking API Security(Project name)
                        </div>
                        <div className="isecDashboard_recent_activity_list_items_time">
                          2mins ago
                        </div>
                      </div>
                      <div className="isecDashboard_recent_activity_list_items_vul">
                        Critical vulnerability in login endpoint
                      </div>
                    </div>
                    <div className="isecDashboard_recent_activity_list_items">
                      <div className="isecDashboard_recent_activity_list_items_project_name_container">
                        <div className="isecDashboard_recent_activity_list_items_project_name">
                          Banking API Security(Project name)
                        </div>
                        <div className="isecDashboard_recent_activity_list_items_time">
                          2mins ago
                        </div>
                      </div>
                      <div className="isecDashboard_recent_activity_list_items_vul">
                        Critical vulnerability in login endpoint
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </>
          )}


        </div>

      </div>

    </div >
  );
};

export default IsecDashboard;